import { IonButton, IonIcon, IonModal, IonSearchbar } from "@ionic/react";
import {
  addCircleOutline,
  closeCircleOutline,
  removeOutline,
} from "ionicons/icons";
import React, { useEffect, useState } from "react";
import { CONSTANTS } from "../../../../constants";
import { utilService } from "../../../../services";
import {
  CareTeamRequestParams,
  CommonProviderRequestParams,
  UpdateCareTeamRequestParams,
} from "../../StatusBoard.model";
import { useToast } from "@agney/ir-toast";
import { statusBoardService } from "../../StatusBoard.service";
import "./StatusBoardAddDeletePopup.scss";
import classNames from "classnames/bind";
import _ from "lodash";
import Loader from "../../../../components/Shared/Loader/Loader";
import InfiniteScroll from "react-infinite-scroll-component";
import { statusBoardSocketService } from "../../StatusBoardSocketService";
import NewSupportStaff from "../NewSupportStaff/NewSupportStaff";
import NoResults from "../../../../components/Shared/NoResults/NoResultsComponent";
import { useTranslation } from "react-i18next";

interface CareTeamProps {
  careTeamList: any;
  showModal: boolean;
  popUpType: any;
  statusBoardId: any;
  onCancel: (data: any) => void;
}

const AddDeletePopup: React.FC<CareTeamProps> = (props) => {
  const { t } = useTranslation("statusBoard");
  let [mainGroupList, setMainGroupList] = useState<any>([]);
  let [initialMainGroupList, setInitialMainGroupList] = useState<any>([]);
  let [allGroupList, setAllGroupList] = useState<any>([]);
  const [isGroupAdditionClicked, setIsGroupAdditionClicked] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [searchText, setSearchText] = useState<string>("");
  const [isLoaderActive, setLoaderStatus] = useState(false);
  const [hasMoreInfiniteScroll, setHasMoreInfiniteScroll] =
    useState<boolean>(true);
  const [showNewSupportStaffPopup, setShowNewSupportStaff] = useState(false);
  const Toast = useToast();
  useEffect(() => {
    const mainGroupList = props.careTeamList
      ? props.popUpType === CONSTANTS.STATUS_BOARD_ROWTYPE.CARE_TEAM
        ? props.careTeamList
        : props.careTeamList
      : [];
    const formattedMainGroupList = addKeys(mainGroupList, 1);
    setMainGroupList(formattedMainGroupList);
    const initialList = _.cloneDeep(props.careTeamList);
    setInitialMainGroupList(initialList);
  }, [props.careTeamList]);

  const onCancel = (data?: any) => {
    props.onCancel(data);
  };

  const addKeys = (groupList: any, listType: any) => {
    groupList = groupList.map((el: any, index: number) => {
      const object = { ...el };
      object["isAdded"] =
        listType !== 2
          ? true
          : object["isAdded"] === undefined
          ? false
          : object["isAdded"];
      return object;
    });
    return groupList;
  };

  const addGroup = () => {
    setIsGroupAdditionClicked(!isGroupAdditionClicked);
    setAllGroupList([]);
    setPageNumber(1);
    if (props.popUpType === 0) {
      if (!isGroupAdditionClicked) {
        getAllCareTeam();
      }
    } else if (props.popUpType === 1) {
      if (!isGroupAdditionClicked) {
        getAllCommonProvider();
      }
    }
  };

  const getAllCareTeam = async () => {
    const params: CareTeamRequestParams = {
      sid: props.statusBoardId,
      page: pageNumber,
      reg_code: utilService.getNetwork(),
    };
    setLoaderStatus(true);
    const respResult: any = await statusBoardService.getAllCareTeam(params);
    if (respResult.isSuccess) {
      setLoaderStatus(false);

      setResponseData(respResult);
    } else {
      setLoaderStatus(false);
    }
  };

  const getAllCommonProvider = async () => {
    const params: CommonProviderRequestParams = {
      sid: props.statusBoardId,
      page: pageNumber,
      reg_code: utilService.getNetwork(),
    };
    setLoaderStatus(true);
    const respResult: any = await statusBoardService.getAllCommonProvider(
      params
    );
    if (respResult.isSuccess) {
      setLoaderStatus(false);
      setResponseData(respResult);
    } else {
      setLoaderStatus(false);
    }
  };

  const handleSearch = (event: any) => {
    setSearchText(event.detail.value!);
    if (props.popUpType === 0 && searchText !== event.detail.value!) {
      handleCareTeamSearch(event.detail.value!);
    } else if (props.popUpType === 1 && searchText !== event.detail.value!) {
      handleCommonProviderSearch(event.detail.value!);
    }
  };

  const handleCareTeamSearch = async (searchValue: string) => {
    const params = {
      name: searchValue,
      sid: props.statusBoardId,
      page: 1,
      reg_code: utilService.getNetwork(),
    };
    setLoaderStatus(true);
    const respResult: any = await statusBoardService.searchCareTeam(params);
    if (respResult.isSuccess) {
      setLoaderStatus(false);
      setResponseData(respResult);
    } else {
      setLoaderStatus(false);
    }
  };

  const handleCommonProviderSearch = async (searchValue: string) => {
    const params = {
      name: searchValue,
      sid: props.statusBoardId,
      page: 1,
      reg_code: utilService.getNetwork(),
    };
    setLoaderStatus(true);
    const respResult: any = await statusBoardService.searchCommonProvider(
      params
    );
    if (respResult.isSuccess) {
      setLoaderStatus(false);
      setResponseData(respResult);
    } else {
      setLoaderStatus(false);
    }
  };

  const setNewAllGroupList = (index: number) => {
    const newList: any = [];
    allGroupList.forEach((element: any, listIndex: number) => {
      if (listIndex === index) {
        element["isAdded"] = true;
      }
      newList.push(element);
    });
    setAllGroupList(newList);
  };

  const setNewMainGroupList = (index: number) => {
    const newList: any = [];
    mainGroupList.forEach((element: any, listIndex: number) => {
      if (listIndex !== index) {
        newList.push(element);
      }
    });
    setMainGroupList(newList);
  };

  const parseAllGroupsList = (groupList: any) => {
    const listType = 2;
    const keyToBeCompared =
      props.popUpType === CONSTANTS.STATUS_BOARD_ROWTYPE.CARE_TEAM
        ? "id"
        : "guid";
    mainGroupList.forEach((obj: any) => {
      const groupListIndex = groupList
        .map((ele: any) => ele[keyToBeCompared])
        .indexOf(obj[keyToBeCompared]);
      if (groupListIndex !== -1) {
        groupList[groupListIndex] = obj;
      }
    });
    groupList = addKeys(groupList, listType);
    return groupList;
  };

  const updateList = (action: Number, index?: any) => {
    switch (action) {
      case CONSTANTS.GROUP_LIST_ACTION.ADD:
        setNewAllGroupList(index);
        mainGroupList.push(allGroupList[index]);

        break;
      case CONSTANTS.GROUP_LIST_ACTION.DELETE:
        setNewMainGroupList(index);
        break;
      case CONSTANTS.GROUP_LIST_ACTION.UPDATE.CARE_TEAM:
        updateCareTeamList();
        break;
      case CONSTANTS.GROUP_LIST_ACTION.UPDATE.COMMON_PROVIDER:
        updateCommonProvider();
        break;
    }
  };

  const getUpdateCareTeamParams = () => {
    const params: UpdateCareTeamRequestParams = {
      statusBoardId: props.statusBoardId,
      addedCareTeam: getMissingCareTeamFromList(
        mainGroupList,
        initialMainGroupList
      ),
      removedCareTeam: getMissingCareTeamFromList(
        initialMainGroupList,
        mainGroupList
      ),
      initialCareTeam: initialMainGroupList.map((obj: any) => obj.id),
      reg_code: utilService.getNetwork(),
    };
    return params;
  };

  const getUpdateCommonProviderParams = () => {
    const params: any = {
      statusBoardId: props.statusBoardId,
      addedCommonProvider: getMissingCareTeamFromList(
        mainGroupList,
        initialMainGroupList
      ),
      removedCommonProvider: getMissingCareTeamFromList(
        initialMainGroupList,
        mainGroupList
      ),
      initialCommonProvider: initialMainGroupList.map((obj: any) => obj.id),
      reg_code: utilService.getNetwork(),
    };
    return params;
  };

  const updateCareTeamList = async () => {
    const params = getUpdateCareTeamParams();
    const respResult: any = await statusBoardService.updateCareTeam(params);
    if (respResult.isSuccess) {
      const socketParams = {
        socketType: CONSTANTS.SOCKET_TYPE.CARE_TEAM_LIST,
        data:
          respResult.groupList && respResult.groupList.length
            ? respResult.groupList[0].careTeam
            : [],
        updatedUniqueId: statusBoardSocketService.uniqueID,
      };
      statusBoardSocketService.sendSbSocketParams(socketParams);
      onCancel(
        respResult.groupList && respResult.groupList.length
          ? respResult.groupList[0].careTeam
          : []
      );
     Toast.success(t("careTeamUpdatedSuccess"));
    } else {
      Toast.error(respResult?.message);
    }
  };

  const updateCommonProvider = async () => {
    const params = getUpdateCommonProviderParams();
    const respResult: any = await statusBoardService.updateCommonProvider(
      params
    );
    if (respResult.isSuccess) {
      const socketParams = {
        data:
          respResult.groupList && respResult.groupList.length
            ? respResult.groupList[0].commonProvider
            : [],
        socketType: CONSTANTS.SOCKET_TYPE.SUPPORT_STAFF_LIST,
        updatedUniqueId: statusBoardSocketService.uniqueID,
      };
      statusBoardSocketService.sendSbSocketParams(socketParams);
      onCancel(
        respResult.groupList && respResult.groupList.length
        ? respResult.groupList[0].commonProvider
        : []
      );
   Toast.success(t("providerAddedSuccess"));
    } else {
      Toast.error(respResult?.message);
    }
  };

  const submitList = () => {
    setIsGroupAdditionClicked(false);
    if (!isGroupAdditionClicked) {
      setDataParams();
    }
  };

  const setDataParams = () => {
    const actionType =
      props.popUpType !== 0
        ? CONSTANTS.GROUP_LIST_ACTION.UPDATE.COMMON_PROVIDER
        : CONSTANTS.GROUP_LIST_ACTION.UPDATE.CARE_TEAM;
    updateList(actionType);
  };

  const getMissingCareTeamFromList = (mainList: any, secondaryList: any) => {
    let existCareTeam;
    const residualObjectsList: any = [];
    mainList.forEach((obj: any) => {
      existCareTeam = utilService.findObject(secondaryList, "id", obj.id);
      if (utilService.isEmpty(existCareTeam)) {
        residualObjectsList.push(obj.id);
      }
    });
    return residualObjectsList;
  };

  const setResponseData = (respResult: any) => {
    const formattedMainGroupList = parseAllGroupsList([
      ...respResult.groupList[0].data,
    ]);
    if (pageNumber === 1) {
      setAllGroupList(formattedMainGroupList);
      setHasMoreInfiniteScroll(true);
    } else {
      setAllGroupList([...allGroupList, ...formattedMainGroupList]);
    }
    if (!respResult.groupList[0].next) {
      setHasMoreInfiniteScroll(false);
    }
    const page =
      isGroupAdditionClicked && respResult.groupList[0].next !== null
        ? pageNumber + 1
        : 1;
    setPageNumber(page);
  };

  const newSupportStaff = () => {
    setShowNewSupportStaff(true);
  };

  const getNextGroupList = () => {
    if (props.popUpType === 0) {
      getAllCareTeam();
    } else {
      getAllCommonProvider();
    }
  };

  return (
    <div>
      <IonModal
        isOpen={props.showModal}
        backdropDismiss={false}
        className="sb-add-delete-popup"
      >
        <div className="add-delete-popup-cont">
          <div className="header-cont">
            <span className="group-title">
              {props.popUpType === CONSTANTS.STATUS_BOARD_ROWTYPE.CARE_TEAM
                ? t("careTeam")
                : t("supportStaff")}
            </span>
            <span className="add-group-text" onClick={addGroup}>
              {!isGroupAdditionClicked && <i className="icon-add"></i>}
              {isGroupAdditionClicked && (
                <IonIcon className="remove-ico" icon={removeOutline} />
              )}
              {t("Add")}{" "}
              {props.popUpType === CONSTANTS.STATUS_BOARD_ROWTYPE.CARE_TEAM
                ? t("careTeam")
                : t("supportStaff")}
            </span>
            {props.popUpType === 1 && (
              <span className="add-group-text" onClick={newSupportStaff}>
                {t("newSupportStaff")}
              </span>
            )}
          </div>

          <div className="list-cont">
            {!isGroupAdditionClicked && (
              <div className="group-list main-group-list">
                {mainGroupList && mainGroupList.length > 0 ? (
                  mainGroupList.map((item: any, index: any) => {
                    return (
                      <span className="flex-items" key={index}>
                        <span
                          onClick={() =>
                            updateList(
                              CONSTANTS.GROUP_LIST_ACTION.DELETE,
                              index
                            )
                          }
                        >
                          <IonIcon
                            className="icon-rem"
                            icon={closeCircleOutline}
                          />
                        </span>
                        <span className="group-name">{item?.name}</span>
                      </span>
                    );
                  })
                ) : (
                 <div className="no-results-label">{t("noResults")}</div>
                )}
              </div>
            )}

            {isGroupAdditionClicked && (
              <div className="all-group">
                <IonSearchbar
                  className="search-input"
                  debounce={1000}
                  value={searchText}
                  onIonChange={(event: any) => handleSearch(event)}
                  placeholder={t("search")}
                  type="search"
                  clearIcon="never"
                ></IonSearchbar>
                {isLoaderActive && (
                  <div className="loader-container">
                    <Loader></Loader>
                  </div>
                )}

                {!isLoaderActive && (
                  <div className="group-list">
                    {allGroupList && allGroupList.length > 0 ? (
                      <InfiniteScroll
                        dataLength={allGroupList.length}
                        height={"270px"}
                        next={() => getNextGroupList()}
                        hasMore={hasMoreInfiniteScroll}
                        loader={""}
                      >
                        {allGroupList.map((item: any, index: any) => {
                          return (
                            <span className="flex-items" key={index}>
                              <span
                                className={classNames({
                                  "icon-disable": item.isAdded,
                                })}
                                onClick={() =>
                                  updateList(
                                    CONSTANTS.GROUP_LIST_ACTION.ADD,
                                    index
                                  )
                                }
                              >
                                <IonIcon
                                  className="icon-ad"
                                  icon={addCircleOutline}
                                />
                              </span>
                              <span className="group-name">{item?.name}</span>
                            </span>
                          );
                        })}
                      </InfiniteScroll>
                    ) : (
                      <div className="no-results-label">
                        <NoResults></NoResults>
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}
          </div>
          <div className="bt-cont">
            <IonButton
              className="btn cancel-btn "
              onClick={() => {
                onCancel();
              }}
            >
              <span>{t("cancel")}</span>
            </IonButton>
            <IonButton
              className="btn save-btn"
              onClick={() => {
                submitList();
              }}
            >
              <span>{t("ok")}</span>
            </IonButton>
          </div>
        </div>
      </IonModal>
      {showNewSupportStaffPopup && (
        <NewSupportStaff
          onCancel={() => setShowNewSupportStaff(false)}
        ></NewSupportStaff>
      )}
    </div>
  );
};

export default AddDeletePopup;
